import React from "react"
export default function MY() {
  return (
    <>
      <svg
        width="32"
        height="24"
        viewBox="0 0 32 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5553_9716)">
          <rect width="32" height="24" rx="2" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0H32V24H0V0Z"
            fill="#F7FCFF"
          />
          <rect x="0.0273438" y="5" width="32" height="2.9" fill="#E31D1C" />
          <rect
            x="0.0273438"
            y="10.1992"
            width="32"
            height="2.9"
            fill="#E31D1C"
          />
          <rect
            x="0.111328"
            y="15.1992"
            width="32"
            height="2.5"
            fill="#E31D1C"
          />
          <rect
            x="0.111328"
            y="20.1992"
            width="32"
            height="2.7"
            fill="#E31D1C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0H32V2.5H0V0Z"
            fill="#E31D1C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0H16V12H0V0Z"
            fill="#3D58DB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.59375 6.20362C3.59375 7.57985 4.24197 8.88126 5.56072 8.88126C7.5393 8.88126 7.92423 8.45944 8.84748 7.87746C9.06576 8.36774 8.3295 10.4658 5.53372 10.4658C3.29746 10.4208 1.49023 8.62428 1.49023 6.20362C1.49023 3.42511 3.53381 1.92456 5.4776 1.94155C7.19363 1.94155 9.01366 2.9153 8.95788 4.15753C8.14934 3.36769 7.27139 3.36769 5.80991 3.36769C4.34842 3.36769 3.59375 4.82723 3.59375 6.20362Z"
            fill="#FECA00"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 7.30078L10.0729 8.65395L10.1183 7.01431L8.57295 7.56414L9.57342 6.26431L8 5.80078L9.57342 5.33726L8.57295 4.03743L10.1183 4.58726L10.0729 2.94761L11 4.30078L11.9271 2.94761L11.8817 4.58726L13.4271 4.03743L12.4266 5.33726L14 5.80078L12.4266 6.26431L13.4271 7.56414L11.8817 7.01431L11.9271 8.65395L11 7.30078Z"
            fill="#FECA00"
          />
        </g>
        <defs>
          <clipPath id="clip0_5553_9716">
            <rect width="32" height="24" rx="2" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}
